import React, {useEffect} from "react";
import {Redirect, useParams} from "react-router";
import {useDispatch} from "react-redux";
import {stickerShowCongratulation} from "../../../store/sticker-show/actions";
import {useSticker} from "../../../store/sticker-show/hooks";
import {setScannedStickerItem} from "../../../store/create-llama/actions";

export default function StickerRedirect() {
    const {id: stickerId} = useParams();
    const dispatch = useDispatch();
    useSticker(stickerId, {scanEvent: true});
    useEffect(() => {
        dispatch(stickerShowCongratulation(true))
        dispatch(setScannedStickerItem())
    }, [])
    return <Redirect exact
                     from="/:id"
                     to={{pathname: `/stickers/${stickerId}`}}
    />
}



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/screens/sticker-redirect/index.tsx